<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <!-- <div class="page">
          <h3>贵州永贵机电制修有限公司</h3>
          <p>H N E C</p>
        </div>
        <p class="slogan">************</p> -->

        <el-carousel indicator-position="outside" height="840px">
          <el-carousel-item v-for="item in imgwrap" :key="item.url">
            <img :src="item.url" class="bannerimg" />
            <!-- <img src="../assets/img/home_top.jpg" /> -->
          </el-carousel-item>
        </el-carousel>
      </swiper-slide>

      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <img src="../assets/img/newstitle.png" />
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in newsList" :key="i">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: news.id } }"
              >
                <div
                  class="item-img"
                  v-lazy:background-image="imgserver + news.img"
                ></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3>{{ news.title }}</h3>
              <p>{{ news.content }}</p>
              <span>{{ news.createTime | dateFormat }}</span>
            </div>
          </div>
        </div>
      </swiper-slide>

      <div class="demo-image">
        <div class="demo-imageone">
          <img src="../assets/img/bwcx.png" />
        </div>

        <!-- <el-image
          style="width: 100%; height: 100%"
          src="../assets/img/bwcx.png"
        ></el-image> -->
      </div>

      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <img src="../assets/img/industrialtitle.png" />
        </div>
        <ul class="case-item">
          <li
            v-for="(item, index) in caseList"
            :key="index"
            v-lazy:background-image="imgserver + item.img"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'casedetails', params: { id: item.id } }"
            >
              <div class="case-item-hover">
                <p class="hover-title">{{ item.title }}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </swiper-slide>
      <!-- <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>企业简介</h3>
        </div>
        
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item, index) in customerList"
              :key="index"
            >
              <el-carousel :interval="5000" arrow="always">
                <el-carousel-item v-for="item in 4" :key="item">
                  <h3>
                    <el-image :src="item.logo"></el-image>
                  </h3>
                </el-carousel-item>
              </el-carousel>
              <div class="customer-content1">
                <small>{{ item.content }}</small>
              </div>
            </div>
          </div>
       
        </div>
      </swiper-slide>  -->

      <swiper-slide style="height:200px" class="slide-foure">
        <div class="happylink">
          友情链接
          <div class="linkborder"></div>
        </div>

        <div class="footimg">
          <div class="footimgone">
            <a href="http://www.gzyngs.cn">
              <img src="../assets/img/footimgone.png" />
            </a>
          </div>

          <div class="footimgtwo">
            <a href="https://www.hnecgc.com.cn">
              <img src="../assets/img/footimgtwo.png" alt="" />
            </a>
          </div>
        </div>

        <div id="footer" class="container-fluid">
          <div style="display:flex">
            <div class="footimage">
              <div class="footimagelogo">
                <img src="../assets/img/footerlogo.png" alt />
              </div>
            </div>
            <div class="logo">
              <p class="title">贵州永贵机电制修有限公司</p>
              <div class="address_tel_fax">
                <div>地址：贵州省黔西县文峰街道循环经济工业园区</div>
                <div style="padding-right:120px">电话：18786512300 胡春华</div>
                <div style="padding-right:160px">传真：0857-7177888</div>
                <div style="padding-right:133px">信访电话：0857-7177888</div>
              </div>
              <p class="email_wx" style="padding-right:110px">
                <span>邮箱：yongguimeiji@126.com</span>
              </p>

              <!-- <p class="email_wx">
              Copyright @2020-2022 贵州永贵机电制修有限公司 版权所有
              <a href="https://beian.miit.gov.cn/" style="color:#fff">黔ICP备2020011664号</a>
          </p> -->
            </div>
            <div class="weixin">
              <div>
                <img src="../assets/img/henanweixin.png" />
              </div>
              <div>
                <img src="../assets/img/gzweixin.png" />
              </div>
              <div class="wenxintitle">关注官方公众号</div>
            </div>
          </div>

          <div class="copy">
            <div>
              <span>技术支持：信息化维保中心</span>
              <span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有：贵州永贵机电制修有限公司</span
              >
              <span
                >&nbsp;&nbsp;&nbsp;&nbsp;工信部网站备案查询
                <a href="https://beian.miit.gov.cn/" style="color:#fff"
                  >黔ICP备2020011664号</a
                ></span
              >
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: true,
      imgwrap: [
        { url: require("../assets/img/home_top.jpg") },
        { url: require("../assets/img/hnec.jpg") },
        { url: require("../assets/img/henc1.jpg") },
        { url: require("../assets/img/hnec2.jpg") },
        { url: require("../assets/img/hnec3.jpg") },
      ],
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Case"),
        this.$http.get(`News/Search?type=1&count=4`),
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data.result;
          this.newsList = responseNews.data.result;
          this.loading = false;
        })
      );
  },
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: black;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  // background: url(../assets/img/home_top.jpg) no-repeat center;
  // background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
.slide-foure {
  height: 100px;
  background-color: #fff;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      color: black;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: black;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: black;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
.foottitle {
  height: 230px;
  background-color: #2874d2;
  margin-top: 100px;
  .titleN {
    margin-top: 25px;
    text-align: center;
    color: #fff;
  }
}
.footimg {
  display: flex;
  margin-left: 600px;
  margin-top: 50px;
  .footimgone {
    background-size: cover;
  }
  .footimgtwo {
    background-size: cover;
  }
}
.happylink {
  text-align: center;
  font-size: 28px;
  size: 25px;
  color: black;
  margin-top: 150px;
  .linkborder {
    width: 50px;
    text-align: center;
    border: 3px #2874d2 solid;
    border-radius: 30px;
    margin-left: 930px;
    margin-bottom: 10px;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
#footer {
  width: 100%;
  height: 550px;
  color: #fff;
  background: url("../assets/img/footer.png");
  overflow: hidden;
  text-align: center;
}
.footimage {
  border-right: 1px solid rgba(255, 255, 255, 0.28);
  height: 200px;
  width: 15%;
  padding-left: 100px;
  padding-top: 60px;
  .footimagelogo {
    width: 280px;
    padding-top: 30px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.weixin {
  height: 220px;
  width: 10%;
  padding-top: 30px;
  margin-left: 200px;
  .weixintitle {
    margin-top: 5px;
    font-size: 14px;
    line-height: 19px;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    word-wrap: break-word;
  }
  img {
    width: 45%;
    line-height: 60px;
  }
}
.logo {
  border-right: 1px solid rgba(255, 255, 255, 0.28);
  height: 220px;
  width: 38%;
  padding-top: 45px;
  margin-left: 150px;
}

.title {
  padding-top: 30px;
  font-size: 25px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  background-color: #041730;

  color: #fff;
  font-size: 14px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
  }
}
.demo-imageone {
  margin-left: 250px;
}
</style>
